import template from './pop-up-list.html';
import controller from './pop-up-list.controller';

let popUpListComponent = {
  bindings: {},
  template,
  controller
};

export default popUpListComponent;


// WEBPACK FOOTER //
// ./client/app/components/pop-up/pop-up-list.component.js